'use client';

import { observer } from 'mobx-react-lite';

import type { ComponentProps, ReactNode } from 'react';

import { globalStore } from '@/app/globalStore';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

/** Title bar button with optional tooltip */
export type TitleBarButtonProps = Omit<ComponentProps<typeof Button>, 'variant' | 'size'> & {
  buttonText?: string;
  tooltip?: ReactNode;
  pressed?: boolean;
  disableWithGlobalOverlay?: boolean;
};

/** Reusable title bar button component with tooltip support */
export const TitleBarButton = observer(({ tooltip, buttonText, children, disabled, disableWithGlobalOverlay = true, pressed, ...props }: TitleBarButtonProps) => {
  const isDisabled = disableWithGlobalOverlay && globalStore.loadingOverlay ? true : disabled;

  return (
    <Button
      variant="titleBar"
      {...props}
      size="titleBar"
      disabled={isDisabled}
      className={cn('titlebarControls', props.className, pressed ? 'bg-primary text-primary-foreground hover:bg-primary' : '')}
      tooltip={tooltip}
    >
      {children}
      {buttonText && <span className="text-sm font-normal">{buttonText}</span>}
    </Button>
  );
});
